export default String.raw`
.reg-container {
    max-width: 100%;
    width: fit-content;
    box-sizing: border-box;
    margin: 24px auto;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0px 0px 4px 0px $dropContainerShadowColor;
    background-color: $bgColor;
    color: $primaryColorFont;
    &__LogIn {
      font-size: 14px;
      font-weight: 400;
      color: $primaryColorFont;
      text-align: center;
      line-height: 20px;
      margin: 24px auto 0;
      display: block;

      a {
        font-weight: 600;
        margin-left: 8px;
      }
    }
    &__header {
        color: $primaryColorFont;
        text-align: left;
        line-height: 32px;
        font-weight: 500;
        font-size: 24px;
        display: block;
        margin: 0 0 24px 0;
    }
    &__data {
      text-align: left;
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
      margin-bottom: 24px;
    }
    a {
      color: $iconColors;
    }
    &__required-fields {
      margin: 8px 0 24px 0;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: #5b5858;
      text-align: left;
    }
    &__select {
      background-position: calc(100% - 10px);
    }
    select::-ms-expand {
      display: none;
    }
    .custom-checkbox {
      width: 15px;
      height: 15px;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      input {
        margin: 0;
      }
    }
    .form__input-wrapper {
      position: relative;
      background-color: inherit;
      margin-bottom: 23px;
    }
    .form__icons:not(.form__preview) {
      color: $primaryColorFont;
      position: absolute;
      transform: translateY(-50%);
      top: 20px;
      left: -30px;
    }
    .checkBoxes__container input:checked+label .checkBoxes__checkIcon {
      top: 0.45rem;
    }
    .checkBoxes__container input + label:before {
      min-width: 16px;
      min-height: 16px;
    }
    .checkBoxes__container input + label {
      padding: 8px 0 8px 0px;
    }
    .consentsList {
      max-width: 514px;
      text-align: left;
    }
    .consentsList .standalone-channel {
      margin-left: 30px;
      text-align: left;
    }
    .simpleLabels {
      min-height: 16px;
      color: $primaryColorFont;
      position: relative;
    }
  }
  
  .change-container {
    margin-bottom: 24px;
    text-align: center;
    position: relative;
  }
  
  .change-container__type {
    display: inline-block;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: $primaryColorFont;
    padding-bottom: 2px;
  }
  
  .change-type-js {
    display: inline-block;
    padding: 0 8px;
    position: relative;
  }
  
  .change-type-js.active {
    color: $iconColors;
  }
  
  .slider {
    position: absolute;
    bottom: 0;
    height: 2px;
    background-color: $iconColors;
    transition: left 0.25s, width 0.25s;
  }
  

  .reg-container__input-wrappers-city > .form__input-wrapper:first-child {
    width: 30%;
  }

  .reg-container__input-wrappers-city > .form__input-wrapper:last-child {
    width: 67%;
  }

  .reg-container__input-wrappers-city {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .reg-container__input-wrappers-home > .form__input-wrapper:first-child {
    width: 48%;
  }

  .reg-container__input-wrappers-home > .form__input-wrapper:last-child {
    width: 49%;
  }
  
  .reg-container__input-wrappers-home {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .reg-container__input-wrappers-personal-data > .form__input-wrapper:first-child {
    width: 48%;
  }

  .reg-container__input-wrappers-personal-data > .form__input-wrapper:last-child {
    width: 49%;
  }

  .reg-container__input-wrappers-personal-data {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .required {
    color: $dangerColor;
  }

  .reg-container .primary-action-button {
    margin: 0 auto 0;
    width: 100%;
    box-sizing: border-box;
    padding: 0.8rem 0;
    display: block;
    height: auto;
  }

  .form__invalid-input.validation-zip-code-js {
    position: static;
    display: flex;
    flex-direction: column;
    width: 150px;

    .zip-format-js {
      width: fit-content;
    }
  }

`